<template>
    <Modal :value="value" @input="$emit('input', false)" :hide-header="true" :larger="true" class="summary-accessory-modal" v-if="product">
        <slider
            animation="fade"
            :autoplay="false"
            :indicators="true"
            id="summaryAccessorySlider"
            :class="product.images.length < 2 ? 'no-slider' : ''"
            v-model="sliderIndex"
        >
            <slider-item
                v-for="(image, index) in product.images"
                :key="index"
            >
                <img v-lazy="image"
                     :alt="product.name"
                     :title="product.name">
            </slider-item>
        </slider>
        <div class="modal-content-wrapper">
            <h2 class="heading">
                {{ product.name }}
            </h2>
            <img :src="$imageUrl('close.svg')" width="25" @click="$emit('input', false)" class="close-icon">
            <p class="description">
                {{ product.description }}
            </p>

            <input v-if="product.embroidery && !$db.accessoriesInCart.includes(product.id)"
                   v-model="embroidery"
                   :placeholder="$tr.summary.accessories.embroidery"
                   maxlength="2"
                   :class="`text-input${embroideryError ? ' invalid' : ''}`"
                   @input="() => { embroideryError = embroidery.trim().length === 0 }">

            <label v-if="product.sizes && product.sizes.length && !$db.accessoriesInCart.includes(product.id)" class="size-label">
                {{ $tr.summary.accessories.size }}:
                <select v-model="size">
                    <option
                        v-for="size in product.sizes"
                        :key="size"
                        :value="size"
                    >
                        {{ size }}
                    </option>
                </select>
            </label>

            <label v-if="product.colors && product.colors.length && !$db.accessoriesInCart.includes(product.id)" class="color-label">
                {{ $tr.summary.accessories.color }}:
                <select v-model="color">
                    <option
                        v-for="color in product.colors"
                        :key="color"
                        :value="color"
                    >
                        {{ color }}
                    </option>
                </select>
            </label>

            <div class="modal-cart-buttons">
                <template v-if="$db.accessoriesInCart.includes(product.id)">
                    <div class="remove-buttons-wrapper">
                        <button
                            class="button success-btn text-center centered-btn"
                            disabled>
                            {{ $tr.summary.accessories.added }}
                        </button>
                        <button
                            class="button sand-btn text-center centered-btn"
                            @click="$emit('removeAccessoryFromCart')">
                            {{ $tr.summary.accessories.remove.btn }}
                        </button>
                    </div>
                </template>
                <div v-else class="price-button-wrapper">
                    <button
                        class="button success-btn text-center centered-btn"
                        @click="() => {
                            if (product.embroidery && embroidery.trim().length === 0)
                                embroideryError = true;
                            else
                                $emit('addAccessoryToCart', {
                                    size,
                                    embroidery,
                                    color,
                                })
                        }">
                        + {{ $tr.summary.accessories.add.btnLong }}
                    </button>
                    <div class="button-price">
                        {{ product.price }}
                    </div>
                </div>
            </div>

            <div class="description-2" v-if="product.description2 && product.description2.trim() !== ''">
                <img :src="$imageUrl('qr.png')">
                <p>
                    {{ product.description2 }}
                </p>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from "../common/Modal";
import {Slider, SliderItem} from "vue-easy-slider";

export default {
    name: "SummaryAccessoryModal",
    props: ['value', 'accessoryDetailId'],
    emits: ['input'],
    data() {
      return {
          size: null,
          color: null,
          embroidery: null,
          embroideryError: false,
          sliderIndex: 0,
      };
    },
    components: {
        Modal,
        Slider,
        SliderItem,
    },
    computed: {
        product() {
            return this.$generalData.accessories.products.find((item) => item.id === this.accessoryDetailId);
        }
    },
    watch: {
        product() {
            if (!this.product.sizes || !this.product.sizes.length)
                this.size = null;
            else
                this.size = this.product.sizes[0];

            if (!this.product.colors || !this.product.colors.length)
                this.color = null;
            else
                this.color = this.product.colors[0];

            this.embroidery = this.product.embroidery ? "" : null;
        },
        color(val) {
            if (!val) {
                return;
            }

            this.sliderIndex = this.product.colors.indexOf(val);
        },
    }
}
</script>
